import React from 'react'
import PropTypes from 'prop-types'
import './_message.scss'
import { useTranslation } from '../../hooks'

const Message = ({ title, copy, icon = <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.05954 8.22125C13.3182 2.96259 19.6195 0.333252 26.9635 0.333252C34.3075 0.333252 40.5875 2.94392 45.8035 8.15992C51.0195 13.3759 53.6302 19.6559 53.6302 26.9999C53.6302 34.3439 51.0195 40.6239 45.8035 45.8399C40.5875 51.0559 34.3075 53.6666 26.9635 53.6666C19.6195 53.6666 13.3369 51.0559 8.12087 45.8399C2.90488 40.6239 0.296875 34.3439 0.296875 26.9999C0.296875 19.6559 2.88621 13.3946 8.05954 8.22125ZM21.5875 43.0426L45.5875 19.0426L41.8382 15.1653L21.5875 35.4159L12.0889 25.9173L8.33687 29.6666L21.5875 43.0426Z" fill="#14B83D"/> </svg> }) => {
  const { i18n } = useTranslation();

  return (
    <section className="message">
      {icon && <span className="message__icon">{icon}</span>}
      {title && <h2 className="message__title">{i18n(title)}</h2>}
      {copy && <p className="message__copy">{i18n(copy)}</p>}
    </section>
  )
}


Message.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  icon: PropTypes.node,
}

export default Message
